export default __webpack_public_path__ + "5822daf.png";